<section class="oauth-auth" aria-labelledby="oauth-auth-title">
  <header class="oauth-auth__header">
    <h1 id="oauth-auth-title" class="oauth-auth__title">
      {{ 'app.oauth.auth.title' | translate }}
    </h1>
    <p class="oauth-auth__subtitle">
      {{ 'app.oauth.auth.subtitle' | translate }}
    </p>
  </header>

  <div class="oauth-auth__form">
    <app-oauth-signin-form
      [requestPending]="isPending()"
      (formSubmitted)="handleSignin($event)"
    />
  </div>
</section>
